/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Injectable } from '@angular/core';
import {ReservationStateModel} from '@core/states/reservation-state/reservation.model';
import { environment } from '@env/environment';
import { ACCEPTED_COOKIE } from '@shared/const/cookies.consts';
import {Carservice} from "rest-client";
import {SERVICE_TYPE_SPACE} from "@app/modules/steps/products-step/utils/product.const";

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private isLoaded = false;
  private gtmId: string;
  private browserGlobals = {
    windowRef(): any {
      return window;
    },
    documentRef(): any {
      return document;
    },
  };

  // How to use:
  //   this.googleTagManagerService.pushOnDataLayer({
  //     event: 'bookingTest',
  //   });

  constructor() {
    this.gtmId = environment.googleTagManager;
  }

  getDataLayer(): any {
    const window = this.browserGlobals.windowRef();
    window['dataLayer'] = window['dataLayer'] || [];
    return window['dataLayer'];
  }

  /** método centralizado para enviar objetos a datalayer */
  pushOnDataLayer(obj: any): void {
    /* DEBUG
    if(obj?.event?.length>0){ console.log(`pushOnDataLayer: ${obj.event}`); }
    if(obj?.event_name?.length>0){ console.log(`BookingAction: ${obj.event_name}`); }
    if(obj?.item_name?.length>0){ console.log(`Ec: item_name: ${obj.item_name}`); }
     */
    const dataLayer = this.getDataLayer();
    dataLayer.push(obj);
  }

  pushBookingActionOnDataLayer(params: any): void {
    if (!params.event_name) {
      params.event_name = 'message';
    }
    const obj = {
      event: 'BookingAction',
      ...params,
    };
    this.pushOnDataLayer(obj);
  }

  pushBookingErrorOnDataLayer(params: any): void {
    const obj = {
      event: 'BookingError',
      ...params,
    };
    this.pushOnDataLayer(obj);
  }

  sendPageView(page: string): void {
    this.pushOnDataLayer({
      event: 'page_view',
      page_title: page.replace(/\/booking\//g, ''),
      page_location: page,
    });
  }

  addGtmToDom(): void {
    /*The default consent should be set very early, before tags read the consent state :)*/
    switch (localStorage.getItem(ACCEPTED_COOKIE)) {
      case 'accept':
        this.consentGranted();
        break;
      case 'reject':
        this.consentDisabled();
        break;
      default:
        this.defaultConsent();
    }
    const doc = this.browserGlobals.documentRef();
    this.gtag('set', 'url_passthrough', true);
    this.gtag('set', 'ads_data_redaction', true);

    this.pushOnDataLayer({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const gtmScript = doc.createElement('script');
    gtmScript.id = 'GTMscript';
    gtmScript.async = true;
    gtmScript.src = '//www.googletagmanager.com/gtm.js?id=' + this.gtmId;
    doc.head.insertBefore(gtmScript, doc.head.firstChild);

    const ifrm = doc.createElement('iframe');
    ifrm.setAttribute(
      'src',
      '//www.googletagmanager.com/ns.html?id=' + this.gtmId
    );
    ifrm.style.width = '0';
    ifrm.style.height = '0';
    ifrm.style.display = 'none';
    ifrm.style.visibility = 'hidden';

    const noscript = doc.createElement('noscript');
    noscript.id = 'GTMiframe';
    noscript.appendChild(ifrm);

    doc.body.insertBefore(noscript, doc.body.firstChild);
    this.isLoaded = true;
  }

  defaultConsent(): void {
    //do nothing
    this.sendConsent('consent', 'default', {});
  }

  consentGranted(): void {
    this.sendConsent('consent', 'update', {
      analytics_storage: 'granted',
      functionality_storage: 'granted',
      security_storage: 'granted',
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });
  }

  consentDisabled(): void {
    this.sendConsent('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'granted',
      personalization_storage: 'denied',
      security_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });
  }

  /**
   * set custom dimensions for GA4
   * @param formVersion
   * @param typeVisitor
   * @param userId
   * @param typeUser
   */
  setCustomVars(
    formVersion: string,
    typeVisitor: string,
    userId: number,
    typeUser: string
  ): void {
    this.pushOnDataLayer({
      dimension: [
        { index: '1', dimension: 'form' },
        { index: '2', dimension: formVersion },
        { index: '3', dimension: typeVisitor },
        { index: '4', dimension: userId },
        { index: '5', dimension: typeUser },
      ],
    });
  }


  // GA4 event for select an item for view. This event is used to measure the number of times a product is viewed.
  // equals old GA 'click' event
  enhancedCommerceEventViewProduct(itemName: string, ItemId: number, itemPrice: number): void {
    this.enhancedECommerceEvent('select_item', itemName, ItemId, itemPrice, 1);
  }

  /**
   *
   * @param method
   * Registration method (e.g., 'email', 'google', 'facebook', 'apple'.)
   */
  signUpEvent(method:string): void {
    this.pushOnDataLayer(
      {
        event: 'sign_up',  // GA4 predefined event for sign-up/register
        method: method,   // Registration method (e.g., 'email', 'google', 'facebook', etc.)
      });
  }
  loginEvent(method:string): void {
    this.pushOnDataLayer(
      {
        event: 'login',  // GA4 predefined event for sign-in (login) event
        method: method,   // sign in method (e.g., 'email', 'google', 'facebook', etc.)
      });
  }

  // GA4 event for adding an item to the cart
  // equals old GA 'ec:setAction' 'add' event
  enhancedCommerceEventAddToCart(itemName: string, ItemId: number, itemPrice: number): void {
    this.enhancedECommerceEvent('add_to_cart', itemName, ItemId, itemPrice, 1);
  }

  // GA4 event for removing an item from the cart
  // equals old GA 'ec:setAction' 'remove' event
  enhancedCommerceEventRemoveFromCart(itemName: string, ItemId: number, itemPrice: number): void {
    this.enhancedECommerceEvent('remove_from_cart', itemName, ItemId, itemPrice, 1);
  }
  enhancedCommerceEventAddCarserviceImpression(
    carservice: Carservice,
    csFamilyPosition: number,
    position: number
  ): void {

    const obj = {
      event: 'ad_impresion',
      item_id: carservice.id,
      item_name: carservice.name_es,
      item_category: carservice.id_carservice_family,
      list: csFamilyPosition,
      position: position,
    };
    this.pushOnDataLayer(obj);
  }

  private enhancedECommerceEvent(
    eventName: string,
    itemName: string,
    itemId: number,
    itemPrice: number,
    itemQuantity: number
  ): void {
    this.pushOnDataLayer({
      'event': eventName,
      'ecommerce': {
        'items': [
          {
            'item_name': itemName,
            'item_id': itemId,
            'price': itemPrice,
            'quantity': itemQuantity
          }
        ]
      }
    });
  }

  /**
   * GA4 event for reservation purchase
   * @param reservation
   */
  enhancedCommerceEventReservationPurchase(reservation: ReservationStateModel): void {
    try {
      const items = [];
      const productPrice = (reservation?.pvp_product_total / 1.21).toFixed(2);

      items.push({
        'item_name': reservation?.product.productName,
        'item_id': reservation?.product.productId,
        'price': productPrice,
        'quantity': 1
      });

      // add extras
      if (reservation?.extras?.length) {
        for (let i = 0; i < reservation?.extras.length; i++) {
          items.push({
            'item_name': reservation?.extras[i].name,
            'item_id': reservation?.extras[i].extra_id,
            'price': reservation?.extras[i].base,
            'quantity': 1,
            'item_category': ( reservation?.extras[i].service_type == SERVICE_TYPE_SPACE )? 'lavado' : 'plaza',
          });
        }
      }
      // add mechanical orders
      if (reservation.mechanical_orders?.length) {
        for (let m = 0; m < reservation?.mechanical_orders.length; m++) {
          items.push({
            'item_name': 'orden mecánica',
            'item_id': reservation.mechanical_orders[m].id,
            'price': reservation.mechanical_orders[m].base,
            'tax': reservation.mechanical_orders[m].vat,
            'quantity': 1,
            'item_category': 'orden mecánica'
          });


          if (reservation.mechanical_orders[m].mechanical_estimate?.car_service_estimates?.length) {
            for (let i = 0; i < reservation.mechanical_orders[m].mechanical_estimate.car_service_estimates.length; i++) {
              items.push({
                'item_name': reservation.mechanical_orders[m].mechanical_estimate.car_service_estimates[i].name,
                'item_id': reservation.mechanical_orders[m].mechanical_estimate.car_service_estimates[i].id_car_service,
                'quantity': 1,
                'item_category': 'Servicio mecánico'
              });
            }
          }
        }
      }

      this.pushOnDataLayer({
        'event': 'purchase',
        'ecommerce': {
          'transaction_id': reservation.id,   // Unique transaction ID for the booking
          'pvp_total': (+reservation.price).toFixed(2), // custom object representing pvp_total
          'value': (+reservation.base_standard + +reservation.base_trans).toFixed(2), // Total value of the transaction (including extras)
          'currency': 'EUR',              // Currency of the transaction
          'tax': (+reservation.vat_standard + +reservation.vat_trans).toFixed(2),                    // Tax amount, if applicable
          'coupon': (reservation?.promos.length) ? reservation.promos[0].name : '',
          'items': items,
          'event_label': 'server confirmation',                   // Equivalent to 'eventLabel' from UA
          'event_action': 'Confirm-booking',                      // Equivalent to 'eventAction' from UA
          'event_category': 'New-booking'                         // Equivalent to 'eventCategory'. IS USED AS A TRIGGER IN GTM
        }
      });
    } catch (error) {
      console.error('Error on enhancedCommerceEventReservationPurchase', error);
    }
  }

  /** arguments is right.  ESLINT tonto */
  /** este método permite enviar usando datalayer, un comando que enviaríamos usando en antíguo script gtag */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  sendConsent(consent: string, type: string, data: any): void {
    // eslint-disable-next-line prefer-rest-params
    this.pushOnDataLayer(arguments);
  }
  /** arguments is right.  ESLINT tonto */
  /** este método permite enviar usando datalayer, un comando que enviaríamos usando en antíguo script gtag */
  //https://developers.google.com/tag-platform/security/guides/consent?consentmode=advanced#upgrade-consent-v2
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  gtag(param1: string, param2: string, param3: any): void{
    // eslint-disable-next-line prefer-rest-params
    this.pushOnDataLayer(arguments);
  }

}
